<template>
	<div class="Box">
		<!--轮播-->
		<div class="swiper">
			<swiper ref="mySwiper" :options="swiperOptions" @slideChange="slideChange" class="banner">
				<swiper-slide v-for="item in banner" class="item">
					<a :href="item.link" target="_blank"><img :src="item.value" :alt="item.detail"></a>
				</swiper-slide>
				<div class="swiper-pagination" slot="pagination"></div>
			</swiper>
		</div>
		<!-- 公司流程简介 -->
		<div class="introduction">
			<div class="video" :data-index="index" @mouseenter="modelEnter($event)" @mouseleave="modelLeave($event)" v-for="(item,index) in model"
			 :key="item.index" @click="openLC(index)">
				<img class="bgVideo" :src="item.pic" alt="">
				<div class="videoItem">
					<div class="introIcon"><img :src="item.value" alt=""></div>
					<div class="introName">{{item.title}}</div>
					<div class="introDet">{{item.introduction}}</div>
				</div>
			</div>
		</div>
		<!--主体-->
		<div class="subject">
			<!-- 电影作品 -->
			<div class="film">
				<div class="workTitle">
					<div class="titleLeft" @click="openMore(31)">
						<img src="../assets/img/film02.png" alt="">
					</div>
					<div class="titleRight" @click="openMore(31)">
						<img src="../assets/img/more.png">
					</div>
				</div>
				<div class="workspan"></div>
				<div class="workGoods">
					<div class="good" v-for="item in film" :key="item.index">
						<div class="goodImg">
							<img :src="item.pic" :alt="item.datail">
						</div>
						<div class="goodTitle">{{item.name}}</div>
					</div>
				</div>
			</div>
			<!-- 电视剧作品 -->
			<div class="film">
				<div class="workTitle">
					<div class="titleLeft" @click="openMore(32)">
						<img src="../assets/img/tv.png" alt="">
					</div>
					<div class="titleRight" @click="openMore(32)">
						<img src="../assets/img/more.png" alt="">
					</div>
				</div>
				<div class="workspan"></div>
				<div class="workGoods">
					<div class="good" v-for="item in tv" :key="item.index">
						<div class="goodImg">
							<img :src="item.pic" :alt="item.datail">
						</div>
						<div class="goodTitle">{{item.name}}</div>
					</div>
				</div>
			</div>
			<!-- 网剧作品 -->
			<div class="film">
				<div class="workTitle">
					<div class="titleLeft" @click="openMore(33)">
						<img src="../assets/img/net.png" alt="">
					</div>
					<div class="titleRight" @click="openMore(33)">
						<img src="../assets/img/more.png" alt="">
					</div>
				</div>
				<div class="workspan"></div>
				<div class="workGoods">
					<div class="good" v-for="item in teleplay" :key="item.index">
						<div class="goodImg">
							<img :src="item.pic" :alt="item.datail">
						</div>
						<div class="goodTitle">{{item.name}}</div>
					</div>

				</div>
			</div>

		</div>
		<!--关于我们-->
		<div class="aboutUs">
			<div class="aboutTitle" @click="openAbout">
				<div class="titleLeft">
					<img src="../assets/img/abouttitle.png" alt="">
				</div>
			</div>
			<div class="aboutBody" @click="openAbout">
				<div class="aboutImg"><img :src="aboutOur.pic" alt=""></div>
				<div class="aboutText">
					<div class="textTitle">{{aboutOur.title}}</div>
					<div class="textBox" v-html="aboutOur.textBody">
						{{aboutOur.textBody}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import axios from 'axios'
	// Vue.use(axios)
	import {
		Swiper,
		SwiperSlide,
		directive
	} from 'vue-awesome-swiper'

	export default {
		name: 'index',
		components: {
			Swiper,
			SwiperSlide
		},
		/* directives: {
			swiper: directive
		}, */
		computed: {
			swiper() {
				return this.$refs.mySwiper.swiper;
			}
		},
		data() {
			return {
				// 首页轮播
				swiperOptions: {
					observer: true, //修改swiper自己或子元素时，自动初始化swiper
					observeParents: true, //修改swiper的父元素时，自动初始化swiper 
					pagination: { //轮播点
						el: '.swiper-pagination',
						bulletClass: 'my-bullet',
						bulletActiveClass: 'my-bullet-active',
						clickable: true,
					},

					loop: true,
					slidesPerView: 3, //页面可视数（网格）
					autoplay: { //自动播放
						delay: 5000,
					},
					centeredSlides: false, //active slide会居中
					centeredSlidesBounds: true, //当设置了Active Slide居中后，还可以配合设置此参数，使得第一个和最后一个Slide 始终贴合边缘
					slideToClickedSlide: true, //点击slide显示当前的slide
					effect: 'coverflow',
					coverflowEffect: {
						rotate: 0, //slide做3d旋转时Y轴的旋转角度。默认50。
						stretch: 10, //每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
						depth: 350, //slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
						modifier: 1, //depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
						slideShadows: true, //开启slide阴影。默认 true。
					}
				},
				banner: [], //获取的轮播图片
				model: [], //获取的六个流程背景图
				film: [], //首页电影
				tv: [], //首页电视剧
				teleplay: [], //首页网剧
				// 首页其他信息
				aboutOur: {}, //关于我们
				companyAddress: "", //地址
				companyPhone: "", //公司电话
				logo: "", //公司logo
				microblog: "", //微博图片
				weChat: "", //微信图片
				companyAddress: "", //公司地址
				companyCode: "", //公司邮编
			}
		},
		computed: {
			swiper() {
				return this.$refs.mySwiper.$swiper
			}
		},

		methods: {
			slideChange() {
				// console.log("当前index", this.swiper.activeIndex);
			},
			//鼠标移入全流程
			modelEnter(e) {
				let bgimg = e.target.firstChild
				bgimg.style.transform = 'scale(1.1,1.1)'
				bgimg.style.transitionDuration = "1s"
			},
			//鼠标移出全流程
			modelLeave(e) {
				let bgimg = e.target.firstChild
				bgimg.style.transform = 'scale(1,1)'
				bgimg.style.transitionDuration = "1s"
			},
			//跳转到全流程
			openLC(index) {
				console.log(index)
				this.$router.push({
					path: "/later",
					query: {
						index: index
					}
				});
				this.$store.state.isActive = "later"
				localStorage.setItem("ishot", "later")
			},
			//跳到更多
			openMore(num) {
				this.$store.state.isActive = "work"
				localStorage.setItem("ishot", "work")
				this.$router.push({
					name: 'work',
					query: {
						num: num
					}
				})
			},
			//跳到关于我们
			openAbout() {
				this.$store.state.isActive = "about"
				localStorage.setItem("ishot", "about")
				this.$router.push({
					name: 'about',
					query: {
						num: 11
					}
				})
			},
			//获取轮播图
			getBanner() {
				this.$api.get(this.$httpApi + this.$path.INDEX_BANNER).then(res => {
					this.banner = res.data.data
					this.swiper.slideNext()
				}).catch(err => {})
			},
			//获取首页流程介绍（六个）
			getModel() {
				this.$api.get(this.$httpApi + this.$path.INDEX_MODEL).then(res => {
					// console.log("首页流程", res.data.data);
					this.model = res.data.data
				}).catch(err => {})
			},
			//统计接口 每次访问首页调用一次"
			static() {
				this.$api.get(this.$httpApi + this.$path.INDEX_STATISTICS).then(res => {
					// console.log("统计接口 每次访问首页调用一次", res.data);
				}).catch(err => {})
			},
			//获取电影信息列表
			getFilmCategory() {
				this.$api.get(this.$httpApi + this.$path.INDEX_MOVIELIST, {
					type: 2,
					offset: 0,
					limit: 4
				}).then(res => {
					// console.log("获取电影分类", res.data);
					this.film = res.data.data
				}).catch(err => {})
			},
			//获取电视剧信息列表
			geTvCategory() {
				this.$api.get(this.$httpApi + this.$path.INDEX_MOVIELIST, {
					type: 3,
					offset: 0,
					limit: 4
				}).then(res => {
					// console.log("获取电视剧分类", res.data);
					this.tv = res.data.data
				}).catch(err => {})
			},
			//获取网剧信息列表
			getTeleplayCategory() {
				this.$api.get(this.$httpApi + this.$path.INDEX_MOVIELIST, {
					type: 5,
					offset: 0,
					limit: 4
				}).then(res => {
					// console.log("获取网剧分类", res.data);
					this.teleplay = res.data.data
				}).catch(err => {})
			},
			//获取首页其他信息
			getOther() {
				this.$api.get(this.$httpApi + this.$path.INDEX_DATALIST).then(res => {
					// console.log("首页其他数据", res.data);
					this.aboutOur = res.data.data.aboutOur;
					this.textBody = res.data.data.aboutOur.textBody;
					this.companyPhone = res.data.data.companyPhone; //公司电话
					this.logo = res.data.data.logo; //公司logo
					this.microblog = res.data.data.microblog; //微博图片
					this.weChat = res.data.data.weChat; //微信图片
					this.companyAddress = res.data.data.companyAddress; //公司地址
				}).catch(err => {})
			}
		},

		mounted() {
			this.static();
			this.getBanner();
			this.getModel();
			this.getFilmCategory();
			this.geTvCategory();
			this.getTeleplayCategory();
			this.getOther();

			// this.$api.get(this.$httpApi + this.$path.INDEX_FLOW).then(res => {
			// 	console.log("获取流程列表", res.data);
			// }).catch(err => {

			// })
			// this.$api.get(this.$httpApi + this.$path.INDEX_MOVIELIST, {
			// 	type: 2
			// }).then(res => {
			// 	console.log("获取影视列表 获取影视信息列表 type 1作品 2电影 3 电视剧 4 网络电影 5网剧", res.data);
			// }).catch(err => {

			// })
			//第一种，全路径请求获取不到
			// this.$api.get('http://192.168.1.184:8081/api/home/getSlideShow').then(res=>{})
			//第二种，用封装好的方法请求也请求不到(改了头信息终于好使了)
			// this.$api.get(this.$httpApi + this.$path.INDEX_BANNER).then(res => {
			// 	console.log(res);
			// 	this.banner = res.data.data;
			// 	console.log("banner", this.banner);
			// }).catch(err => {

			// })
			//第三种，用封装好的方法路径请求，是请求的本地，封装的域名没生效，也请求不到
			// this.$api.get(this.$path.INDEX_BANNER).then(res=>{}).catch(err=>{ })
			//第四种，出错
			// this.$axios.post('http://59.110.161.46:8081/api/home/getSlideShow').then(res=>{
			// 	console.log(res)
			// })
			//第五种，直接引入axios请求，也请求不到
			// axios.get('http://59.110.161.46:8081/api/home/getSlideShow').then((res)=>{
			//                 console.log(res);
			// });
			// this.$axios({
			//   method: 'get',
			//   url: 'http://59.110.161.46:8081/api/home/getSlideShow',
			//   data: {
			//     firstName: 'Fred',
			//     lastName: 'Flintstone'
			//   }
			// });
		}
	}
</script>
<style>
	.my-bullet {
		width: 0.20rem;
		height: 0.20rem;
		display: inline-block;
		border: #ffffff 0.01rem solid;
		border-radius: 100%;
		margin-right: 0.20rem;
	}

	.my-bullet-active {
		background-color: #D20617;
		opacity: 1;
	}
</style>
<style scoped>
	.Box {
		width: 19.20rem;
	}

	.swiper {
		width: 100%;
		height: 9.33rem;
		background-color: #0b0701;
	}

	.banner {
		width: 100%;
		height: 9.30rem;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;

	}

	.item img {
		width: 100%;
		height: 100%;
		font-size: 0.24rem;
	}

	/* 公司简介 */
	.introduction {
		width: 100%;
		height: 8.62rem;
		background-color: #0F0F0F;
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		padding: 0.75rem 0;
		box-sizing: border-box;
	}

	.video {
		width: 5.42rem;
		height: 3.48rem;
		border: 0.01rem solid #000000;
		box-sizing: border-box;
		margin: 0 0.04rem;
		position: relative;
		overflow: hidden;
	}

	.video:hover {
		cursor: pointer;
	}

	.bgVideo {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 11;
	}

	.bgVideo:hover {
		transform: scale(1.1, 1.1);
	}

	.videoItem {
		width: 100%;
		height: 100%;

		position: absolute;
		left: 0;
		top: 0;
		z-index: 22;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.introIcon {
		width: 1.00rem;
		height: 1.00rem;
	}

	.introIcon img {
		width: 100%;
		height: 100%;
	}

	.introName {
		width: 100%;
		height: 0.60rem;
		color: #FFFFFF;
		line-height: 0.60rem;
		font-size: 0.36rem;
		letter-spacing: 0.04rem;
		font-weight: 300;
	}

	.introDet {
		width: 100%;
		height: 0.40rem;
		color: #FFFFFF;
		line-height: 0.40rem;
		font-size: 0.24rem;
		letter-spacing: 0.03rem;
		font-weight: 300;
	}

	/* 主体内容 */
	.subject {
		width: 100%;
	}

	.film {
		width: 100%;
		height: 8.78rem;
		background: #0F0F0F;
	}

	.workTitle {
		width: 100%;
		height: 1.54rem;
		border-top: 0.02rem solid #666666;
		box-sizing: border-box;
		position: relative;
	}

	.workspan {
		width: 100%;
		height: 0.02rem;
		background-image: linear-gradient(to right, #666666, #202020, #0F0F0F);
	}

	.titleLeft {
		min-width: 0.95rem;
		height: 0.56rem;
		float: left;
		margin-left: 1.40rem;
		margin-top: 0.48rem;
		cursor: pointer;
	}

	.titleLeft img {
		height: 100%;
		display: block;

	}

	.titleRight {
		width: 0.56rem;
		height: 0.11rem;
		position: absolute;
		right: 1.40rem;
		bottom: 0.42rem;
		cursor: pointer;
	}

	.titleRight img {
		width: 100%;
		height: 100%;
		display: block;
	}

	.workGoods {
		width: 100%;
		height: 7.24rem;
		display: flex;
		justify-content: space-between;
		padding: 0.79rem 1.42rem 0 1.42rem;
		box-sizing: border-box;
	}

	.good {
		width: 3.09rem;
		height: 5.50rem;
	}

	.goodImg {
		width: 3.09rem;
		height: 4.31rem;
		margin-bottom: 0.95rem;
	}

	.goodImg img {
		width: 100%;
		height: 100%;
	}

	.goodTitle {
		width: 100%;
		height: 0.24rem;
		font-size: 0.20rem;
		color: #ffffff;
		text-align: center;
		line-height: 0.24rem;
		font-weight: 600;
		letter-spacing: 0.02rem;
	}

	/* 关于我们 */

	.aboutUs {
		width: 100%;
		min-height: 9.80rem;
		background: #0F0F0F;
	}

	.aboutTitle {
		width: 100%;
		height: 1.54rem;
		border-top: 0.02rem solid #666666;
		box-sizing: border-box;
		position: relative;
	}

	.aboutBody {
		width: 100%;
		min-height: 8.10rem;
		background: #0F0F0F;
		padding-top: 0.71rem;
		box-sizing: border-box;
	}

	.aboutImg {
		width: 16.44rem;
		height: 3.98rem;
		margin: 0 auto;
	}

	.aboutImg>img {
		width: 100%;
		height: 100%;
	}

	.aboutText {
		width: 12.30rem;
		min-height: 2.00rem;
		margin: 0.71rem auto;
		color: #ffffff;
	}

	.aboutText:hover {
		color: #1996f6;
		cursor: pointer;
	}

	.textTitle {
		width: 100%;
		height: 0.40rem;
		font-size: 0.32rem;
		text-align: center;
		margin-bottom: 0.40rem;
	}

	.textBox {
		width: 100%;
		height: auto;
		font-size: 0.18rem;
		font-weight: 300;

		line-height: 0.35rem;
		text-align: justify;
	}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue